module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/operations.c87f648f.svg";